/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/compliance/rule'

// Action Types
export const GET_COMPLIANCE_RULES = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_COMPLIANCE_RULES'
)

export const CHANGE_STATE = ReduxHelpers.Types.createActionType(
  prefix,
  'CHANGE_STATE'
)

export const GET_COMPLIANCE_RULES_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_COMPLIANCE_RULES_PENDING'
)
